<template>
    <div class="OrderWrap">
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>MY<span> ORDER</span></p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div class="Item flexa">
            <div class="List flexa"><span  @click="GetOrderList('', 0)" :class="{ Active: stateindex == 0 }">全部</span><span @click="GetOrderList(item.state, index + 1)"  :class="{ Active: index + 1 == stateindex }" v-for="(item,index) in itemlist" :key="index">{{ item.state }}</span></div>
           <!-- <div class="List flexa"><span class="Active">按时间</span><span>按金额</span></div>-->
        </div>
        <div class="OrderDetailWrap" v-if="detailstate">
                <div class="LineCut flexbetween">
                    <div class="NewsTitle flexa"><p>{{ OrderDetailsData.basedata.订单状态 }}订单</p></div>
                    <div class="Return flexa" @click="closedetail"><p>返回</p><img src="../../assets/Home/return.png"></div>
                </div>
                <div class="PayforWrap">
                    <!-- 内容 -->
                    <div class="OrderContentWrap">
                        <div class="ProductInfo">
                            <i class="Pic"><img :src="OrderDetailsData.basedata.LOGO图"/></i>
                            <div class="Name">
                                <p>{{ OrderDetailsData.basedata.产品名称 }}</p>
                            </div>
                            <div class="Time">
                                <p>{{ OrderDetailsData.basedata.产品类型 }}</p>
                            </div>
                            <div  v-if="OrderDetailsData.basedata.定制 === '0'"  class="Intro">
                                <p>
                                    {{ OrderDetailsData.basedata.详情介绍 }}
                                </p>
                            </div>
                            <div v-else class="MoreContent">
                                <div class="Title1">
                                    <p>定制内容</p>
                                </div>
                                <div class="CommList">
                                    <p>{{ OrderDetailsData.basedata.基础功能介绍 }}</p>
                                    <p>基于上述功能的个性化服务与系统化定制</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 钱数 -->
                    <div class="MoneyCount">
                        <div
                                class="Title flexa"
                                v-if="OrderDetailsData.basedata.定制 === '0'"
                        >
                            <p style="width: 50%;text-align: left;margin-right: 0">
                                基础功能
                            </p>
                            <p style="width:49%;margin-right: 0;text-align: right;color:#d5b338">
                                ￥{{ OrderDetailsData.basedata.基础金额 }}/用户/年
                            </p>
                        </div>
                        <div v-if="OrderDetailsData.basedata.定制 === '0'">
                            <p
                                    style="width: 100%;margin: 0.1rem auto;text-align: left;opacity: 0.8"
                            >
                                {{ OrderDetailsData.basedata.基础功能介绍 }}
                            </p>
                        </div>
                        <div class="Title flexa"  v-if="OrderDetailsData.moredata.length > 0">附加功能</div>
                        <div
                                class="flexbetween"
                                v-for="(item, index) in OrderDetailsData.moredata"
                                :key="index"
                                style="margin-top: 0.05rem"
                        >
                            <p style="width: 61.5%;">
                                {{ item.名称 }}
                            </p>
                            <p style="width: 37.5%;margin-right: 0;color:  #d5b338">￥{{ item.金额 }}/用户/年</p>
                        </div>
                        <div style="width: 100%;" v-if="OrderDetailsData.basedata.定制 === '1'">
                        <div class="Title flexa">开发者</div>
                        <div><p style="width: 100%;margin-top: 0.05rem">{{ OrderDetailsData.basedata.开发者姓名 }}</p></div>
                        <div class="Title flexa">企业名称</div>
                        <div><p style="width: 100%;margin-top: 0.05rem">{{ OrderDetailsData.basedata.企业名称 }}</p></div>
                        </div>
<!--                        <div class="Title flexa">订单金额</div>
                        <div class="PriceCount1">
                            <div style="width: 100%;" v-if="OrderDetailsData.basedata.定制 === '0'">
                            <div  v-if="OrderDetailsData.basedata.结束日期" class="flexbetween" style="margin: 0.05rem auto;width: 100%">
                                <div style="width: 61%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        用户数 {{ OrderDetailsData.basedata.用户数 }}
                                    </p>
                                </div>
                                <div style="width: 39%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        有效期至 {{ OrderDetailsData.basedata.月份数 }}
                                    </p>
                                </div>
                            </div>
                            <div v-else  class="flexbetween" style="margin: 0.05rem auto;width: 100%">
                                <div style="width: 61%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        用户数 {{ OrderDetailsData.basedata.用户数 }}
                                    </p>
                                </div>
                                <div style="width: 39%">
                                    <p style="font-size: 0.05rem;width: 100%;color: #fff">
                                        有效期1年
                                    </p>
                                </div>
                            </div>
                            </div>
                            <div style="text-align: right;width: 100%;margin-top: 0.1rem">
                                <span style="font-size: 0.065rem;color: #fff;margin-right: 0.1rem">总金额</span>
                                <span style="font-size:0.075rem;color: #d5b338;"
                                >￥{{ OrderDetailsData.basedata.订单金额 }}</span
                                >
                            </div>
                        </div>-->
                        <div class="Title flexa">订单信息</div>
                        <div>
                        <div class="flexbetween" style="margin-top: 0.05rem;width: 100%">
                            <p style="width: 61.5%;" v-if="OrderDetailsData.basedata.定制 === '1'">有效期</p>
                            <p style="width: 61.5%;" v-else>用户数 {{ OrderDetailsData.basedata.用户数 }}</p>
                            <p style="width: 37.5%;margin-right: 0;color: #cbcbcb"  v-if="OrderDetailsData.basedata.截止日期" >有效期至 {{ OrderDetailsData.basedata.截止日期 }}</p>
                            <p style="width: 37.5%;margin-right: 0;color: #cbcbcb"  v-else >有效期1年</p>
                        </div>
                        </div>
                        <div class="flexbetween" style="margin-top: 0.05rem">
                            <p style="width: 61.5%;">订单时间</p>
                            <p style="width: 37.5%;margin-right: 0;color: #cbcbcb">{{ OrderDetailsData.basedata.订单时间 }}</p>
                        </div>
                        <div class="flexbetween" style="margin-top: 0.05rem">
                            <p style="width: 61.5%;">订单编号</p>
                            <p style="width: 37.5%;margin-right: 0;color: #cbcbcb">{{ OrderDetailsData.basedata.订单编号 }}</p>
                        </div>
                        <div class="flexbetween" style="margin-top: 0.05rem" v-if="OrderDetailsData.basedata.支付单号">
                            <p style="width: 61.5%;">支付单号</p>
                            <p style="width: 37.5%;margin-right: 0;color: #cbcbcb">{{ OrderDetailsData.basedata.支付单号 }}</p>
                        </div>
                        <div class="flexbetween" style="margin-top: 0.05rem" v-if="OrderDetailsData.basedata.订单状态.replace(/\s*/g,'')!=='待支付'&&OrderDetailsData.basedata.支付单号!==null">
                            <p style="width: 61.5%;">支付平台</p>
                            <p style="width: 37.5%;margin-right: 0;color: #cbcbcb">{{ OrderDetailsData.basedata.支付平台 }}</p>
                        </div>
                        <div class="flexbetween" style="margin-top: 0.05rem" v-if="OrderDetailsData.basedata.支付时间">
                            <p style="width: 61.5%;">支付时间</p>
                            <p style="width: 37.5%;margin-right: 0;color: #cbcbcb">{{ OrderDetailsData.basedata.支付时间 }}</p>
                        </div>
                        <div style="text-align: right;margin-top: 0.1rem">
                            <span style="font-size: 0.065rem;color: #fff;margin-right: 0.1rem">总金额</span>
                            <span style="font-size:0.075rem;color: #d5b338;font-weight: bold"
                            >￥{{ OrderDetailsData.basedata.订单金额 }}</span
                            >
                        </div>
                    </div>
                </div>
                <!-- 底部汇总 -->
                <div class="Foot" v-if="orderstate === '待支付'">
                    <div class="ButtonWrap clearfix">
                        <div class="flex Yes" @click="Payfor"><span>去支付</span></div>
                        <div class="flex No" @click="StopOrder"><span>取消订单</span></div>
                    </div>
                </div>
            </div>
        <div class="ContentListWrap">
            <ul>
                <!-- 待支付样式 -->
                <li v-for="(item,index) in OrderListData" :key="index" @click="OpenDetailBox(item.订单编号, item.订单状态, item.支付金额)">
                    <div class="Name">
                        <p>{{ item.订单状态 }}</p>
                        <p>{{ item.产品名称 }}</p>
                    </div>
                    <div class="Time">
                        <div class="Top clearfix">
                            <p>订单号 <span>{{ item.订单编号 }}</span></p>
                            <p>{{ item.时间 }}</p>
                        </div>
                    </div>
                    <div class="ButtonWrap flexbetween">
                        <div class="Type flexa">
                            <div class="flex color1" v-if="item.业务分类==='云产品'"><p>{{ item.业务分类 }}</p></div>
                            <div class="flex color4" v-else><p>{{ item.业务分类 }}</p></div>
                        </div>
                        <div class="Next">
                            <div><p>{{ item.订单类型 }}</p></div>
                            <div><p>￥{{ item.支付金额 }}</p></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="buystate">
            <div class="Login">
                <div class="LoginContentWrap">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 请支付...</p></div>
                    <div class="CloseBox" @click="closepay('Web_WechatOrderQuery')"><img src="../../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div v-if="!payss">
                        <div class="CodeWrap">
                            <!--   <img :src="code">-->
                            <img :src="code">
                        </div>
                        <div class="flex Tip"><p>请使用微信扫描二维码支付</p></div>
                        <div class="flex ReButton" @click="Check('Web_WechatOrderQuery')">支付成功后点击这里刷新</div>
                    </div>
                    <div v-else class="flex" style="width: 100%;height:70%">
                        <i   @click="SubmitOrderData('M0042510000000000000000002')"  style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../../assets/al.png"></i>
                        <i   @click="SubmitOrderData('M0042510000000000000000001')"  style="width: 0.6rem;margin: 0 0.18rem;cursor: pointer"><img style="width: 100%" src="../../assets/wx.png"></i>
                    </div>
                    <div v-if="payss" class="flex ReButton" style="cursor: auto">请选择支付方式</div>
                </div>
            </div>
        </div>
        <!-- 购买支付 -->
        <div class="BuyBox" v-if="alstate">
            <div class="Login">
                <div class="LoginContentWrap" style="width: 1.8rem;height: 1.5rem">
                    <div class="LoginTitle"><p><strong>Hello!</strong> 正在支付中...</p></div>
                    <div class="CloseBox" @click="closepay('Web_AlipayTradeQuery')"><img src="../../assets/Home/exit1.png"></div>
                    <!-- 支付二维码 -->
                    <div style="margin-top: 0.4rem">
                        <div class="flex Tip"><p>支付完成前请不要关闭此验证窗口</p></div>
                        <div class="flex ReButton" @click="Check('Web_AlipayTradeQuery')">支付成功后点击这里刷新</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    inject: [
      'load'
    ],
    data() {
      return {
        buystate: false,
        payss: true,
        code: '',
        noworder: '',
        alstate: false,
        lastmoney: 0,
        detailstate: false,
        orderstate: '待支付',
        OrderDetailsData: {
          basedata: {},
          moredata: [],
          statedata: {}
        },
        OrderListData: [],
        stateindex: 0,
        itemlist: [
          {
            state: '待支付'
          },
          {
            state: '已支付'
          },
          {
            state: '已取消'
          }
        ]
      };
    },
    computed: {
      ...mapGetters(['LoginUserInfo'])
    },
    methods: {
      Check(param) {
        this.load.show();
        this.$utils.CheckPayfor(this.noworder, 'GoeasyUser' + this.LoginUserInfo.userId, param).then(res => {
          console.log(res);
          this.load.hide();
          if (res.data.code === 0) {
            this.$confirm('支付成功！请前往“个人中心-注册平台”进行企业注册！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '返回',
              showClose: false,
              closeOnClickModal: false,
              type: 'success'
            }).then(() => {
              this.$router.push({
                name: 'PersonCenter'
              });
            }).catch(() => {
              this.buystate = false;
              this.payss = true;
              this.alstate = false;
              this.detailstate = false;
              this.GetOrderList('待支付', 1);
            });
          } else {
            this.$confirm('您还没有支付成功！是否继续支付？', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              closeOnClickModal: false,
              type: 'error'
            }).then(() => {
              console.log('未支付');
            }).catch(() => {
              this.buystate = false;
              this.payss = true;
              this.alstate = false;
            });
          }
        }).catch(error => {
          this.load.hide();
          this.$message.error(error);
        });
      },
      Payfor() {
        this.buystate = true;
      },
      closepay(param) {
        this.Check(param);
      },
      /* 支付前提交支付信息平台(选取支付平台最终支付调用) */
      SubmitOrderData(num) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
          data: {
            commandId: 'WBA0007010',
            buttonText: 'Verify',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            orderNumber: this.noworder,
            headData: {
              支付平台: num
            },
            saveGridData: 1
            /*   gridData: this.chooseitems */
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              if (num === 'M0042510000000000000000007') {
                /* 苹果支付 */
              } else if (num === 'M0042510000000000000000002') {
                /* 支付宝 */
                this.$utils.AliPay_Web(this.noworder, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.alstate = true;
                  this.buystate = false;
                  window.open(res.data.data, '_blank');
                  // eslint-disable-next-line no-useless-escape
                  console.log(res.data);
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              } else {
                /* 微信 */
                this.$utils.WXPay_Web(this.noworder, 'GoeasyUser' + this.LoginUserInfo.userId).then(res => {
                  this.load.hide();
                  this.payss = false;
                  this.alstate = false;
                  console.log(res);
                  this.code = res.data.data;
                }).catch(error => {
                  this.load.hide();
                  console.log(error);
                });
              }
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      StopOrder() {
        this.$confirm('确认取消当前订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '返回',
          showClose: false,
          closeOnClickModal: false,
          type: 'warning'
        })
          .then(() => {
            this.load.show();
            this.$axios({
              method: 'POST',
              url: 'https://x6.goeasy.cn/cli/client/Web_OnClickButtonOfBill',
              data: {
                commandId: 'WBA0007010',
                buttonText: 'Stop',
                userId: 'GoeasyUser' + this.LoginUserInfo.userId,
                orderNumber: this.noworder,
                saveGridData: 1
                /*   gridData: this.chooseitems */
              }
            })
              .then(res => {
                this.load.hide();
                if (res.data.code === 0) {
                  console.log(res);
                  this.GetOrderList(this.orderstate, this.stateindex);
                  this.detailstate = false;
                } else {
                  this.$message.error(res.data.msg);
                }
              })
              .catch(error => {
                this.load.hide();
                this.$message.error(error);
                console.log(error);
              });
          })
          .catch(() => {
            console.log('取消');
          });
      },
      closedetail() {
        this.detailstate = false;
      },
      /* 获取邮箱 */
      GetEmail() {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007042',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              this.detailstate = true;
              this.email = res.data.data.DETAIL[0].客服邮箱;
              console.log(res);
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 订单详情信息获取 */
      GetOrderDetailsStateData(od) {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007015',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            orderNumber: od
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              this.OrderDetailsData.statedata = res.data.data.DETAIL;
              this.GetEmail();
              console.log(res);
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 订单详情信息获取 */
      GetOrderDetailsMoreData(od) {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007014',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            orderNumber: od
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.OrderDetailsData.moredata = res.data.data.DETAIL;
              this.GetOrderDetailsStateData(od);
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 订单详情信息获取 */
      GetOrderDetailsBaseData(od) {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007013',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            orderNumber: od
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.OrderDetailsData.basedata = res.data.data.DETAIL[0];
              this.GetOrderDetailsMoreData(od);
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      OpenDetailBox(orderid, state, money) {
        this.orderstate = state;
        this.lastmoney = money;
        this.noworder = orderid;
        this.load.show();
        this.GetOrderDetailsBaseData(orderid);
      },
      Return() {
        this.$router.back();
      },
      /* 获取订单列表 */
      GetOrderList(state, index) {
        this.orderstate = state;
        console.log(state);
        this.stateindex = index;
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007046',
            userId: 'GoeasyUser' + this.LoginUserInfo.userId,
            filter: { 订单状态: state }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              this.OrderListData = res.data.data.DETAIL;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            console.log(error);
            this.$message.error(error);
          });
      }
    },
    created() {
      console.log(this.$route.params);
      if (this.$route.params.orderstate && this.$route.params.index) {
        this.GetOrderList(this.$route.params.orderstate, this.$route.params.index);
      } else {
        this.GetOrderList('', 0);
      }
    }
  };
</script>
<style lang="scss" scoped>
    @import '../../../public/Value';
    .OrderWrap{
        width: 100%;
        .BuyBox{
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 4;
            .Login {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.6);
                z-index: 4;
                display: flex;
                -webkit-justify-content: center;
                -webkit-align-items: center;
                .LoginContentWrap {
                    width: 2.7rem;
                    height: 2.78rem;
                    border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
                    background: linear-gradient(to bottom right, #6666cc, #4141b3);
                    position: relative;
                    .CloseBox {
                        width: 0.15rem;
                        height: 0.15rem;
                        position: absolute;
                        cursor: pointer;
                        right: 0.05rem;
                        top: 0.05rem;
                        z-index: 4;

                        img {
                            width: 100%;
                        }
                    }
                    .NeedKnown {
                        position: absolute;
                        width: 100%;
                        bottom: 0.1rem;

                        p {
                            font-size: $SmallTextSize;
                            color: #fff;
                            text-align: center;

                            span {
                                cursor: pointer;
                                font-weight: bold;
                                margin: 0 0.02rem;
                                color: #999900;
                            }
                        }
                    }
                    .LoginTitle {
                        width: 100%;
                        margin-top: 0.05rem;

                        p {
                            font-size: $TextSize;
                            color: #fff;
                            text-indent: 0.05rem;
                        }
                    }
                }
            }
            .ReButton{
                width: 1.3rem;
                height: 0.2rem;
                background-color: #9797ff;
                color: #fff;
                font-size: $TextSize;
                margin: 0.3rem auto 0;
                border-radius: 0.2rem;
                cursor: pointer;
            }
            .CodeWrap{
                width: 1.3rem;
                height: 1.3rem;
                background-color: #fff;
                margin: 0.3rem auto 0.1rem;
                border: 0.02rem solid #fff;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .Tip{
                width: 100%;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    margin: 0 0.03rem;
                }
                p:last-child{
                    font-size: $TextSize;
                    font-weight: bold;
                    color: #ceceff;
                }
            }
        }
        .OrderDetailWrap{
            .Foot {
                width: 100%;
                height: 0.6rem;
                .ButtonWrap {
                    width: 90%;
                    margin: 0 auto;
                    position: relative;
                    div:last-child {
                        margin-left: 0 !important;
                    }
                    .Yes,
                    .No {
                        width: 0.8rem;
                        height: 0.25rem;
                        float: right;
                        margin-left: 0.1rem;
                        background-color: #26a2ff;
                        border-radius: 0.8rem;
                        cursor: pointer;
                        span {
                            font-size: $TextSize;
                            color: #fff;
                        }
                    }
                    .Yes {
                        background-color: #8c73b5;
                    }
                    .No {
                        background-color: #666666;
                    }
                }
                .Count {
                    width: 6.3rem;
                    height: 0.8rem;
                    margin: 0 auto;
                    p {
                        font-size: 0.32rem;
                        text-align: right;
                        font-weight: bold;
                        color: #666666;
                    }
                }
            }
            .PayforWrap {
                width: 90%;
                margin: 0 auto;
                .ChooseComp {
                    width: 100%;
                    padding: 0.2rem 0;
                    ul {
                        width: 100%;
                        overflow-x: scroll;
                        overflow-scrolling: touch;
                        height: 1rem;
                        text-align: left;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        white-space: nowrap;
                        overflow-y: hidden;
                        li {
                            width: 1rem;
                            height: 0.3rem;
                            background-color: #666666;
                            display: inline-block;
                            margin-right: 0.02rem;
                            border-radius: 0.03rem;
                            div {
                                width: 100%;
                                height: 100%;
                            }
                            p {
                                font-size: $TextSize;
                                color: #fff;
                            }
                        }
                        li.Active {
                            background-color: #8c73b5;
                        }
                    }
                }
                .MoneyCount {
                    width:100%;
                    margin: 0.05rem auto 0;
                    padding-bottom: 0.1rem;
                    .Times {
                        width: 98%;
                        margin: 0.02rem auto;
                        div {
                            font-size: $AdditionTextSize;
                            width: 1rem;
                            float: left;
                            margin-bottom: 0.04rem;
                            input {
                                width: 0.1rem;
                                height: 0.1rem;
                                border-radius: 0.1rem;
                                margin-right: 0.05rem;
                            }
                        }
                    }
                    .TypeChooseWrap {
                        width: 100%;
                        .Types,
                        .TypesMore {
                            width: 0.8rem;
                            height: 0.5rem;
                            margin-right: 0.04rem;
                            border-radius: 0.08rem;
                            cursor: pointer;
                            background-color: #dee7eb;
                            float: left;
                            .Choosed {
                                box-sizing: border-box;
                                .Money {
                                    width: 90%;
                                    margin:0 auto;
                                    p {
                                        width: 94%;
                                        text-align: right;
                                        font-size: $SmallTitleSize;
                                        color: #626262;
                                        font-weight: bold;
                                    }
                                }
                                .Number {
                                    width: 90%;
                                    margin: 0.05rem auto 0.08rem;
                                    p {
                                        font-size: $SmallTitleSize;
                                        font-weight: bold;
                                        width: 100%;
                                        text-align: left;
                                    }
                                }
                                p {
                                    font-size: $AdditionTextSize;
                                    color: #414141;
                                }
                                input {
                                    width: 0.1rem;
                                    height: 0.1rem;
                                    border-radius: 0.04rem;
                                    margin: 0.05rem 0 0 0.05rem;
                                }
                            }
                        }
                        > div:nth-child(4n) {
                            margin-right: 0;
                        }
                    }
                    .Title {
                        width: 100%;
                        height: 0.15rem;
                        font-size: $TextSize;
                        color: #fff;
                        border-bottom: 1px solid #c9c9c9;
                    }
                    div {
                        width: 98%;
                        margin: 0 auto;
                        p {
                            font-size: $TextSize;
                            color: #fff;
                            text-align: right;
                            width: 40%;
                            margin-right: 0.1rem;
                        }
                        p:first-child {
                            width: 58%;
                        }
                    }
                }
                &::-webkit-scrollbar {
                    display: none;
                }
                .OrderContentWrap {
                    width:100%;
                    margin: 0 auto;
                    .MoreContent{
                        width: 100%;
                        margin: 0 auto;
                        .Title1 {
                            width: 100%;
                            margin: 0.12rem auto 0.08rem;
                            p {
                                font-size: $SmallTitleSize;
                                color: #fff;
                            }
                        }
                        .CommList {
                            border-radius: 0.07rem;
                            border: 1px solid #fff;
                            box-sizing: border-box;
                            padding: 0.12rem 0.08rem 0.1rem;
                            p {
                                font-size: $TextSize;
                                color: #fff;
                                line-height: 0.09rem;
                            }
                        }
                    }
                    .ProductInfo {
                        width: 100%;
                        margin: 0 auto;
                        padding-bottom: 0.05rem;
                        padding-top: 0.05rem;
                        position: relative;
                        .Name {
                            margin-top: 0.05rem;
                            p {
                                font-size: $SmallTitleSize;
                                font-weight: bold;
                                color: #fff;
                            }
                        }
                        .Time {
                            margin-top: 0.05rem;
                            p {
                                font-size: $SmallTextSize;
                                color: #fff;
                                opacity: 0.8;
                            }
                        }
                        .Intro {
                            margin-top: 0.05rem;
                            p {
                                font-size: $TextSize;
                                color: #fff;
                                line-height: 0.1rem;
                            }
                        }
                        .Pic {
                            width: 0.4rem;
                            height: 0.4rem;
                            border-radius: 0.1rem;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 0.1rem;
                            }
                        }
                    }
                }
                .Step {
                    width: 100%;
                    .StepList {
                        width: 100%;
                        margin-bottom: 0.1rem;
                        .Time {
                            width: 0.4rem;
                            p {
                                font-size: $TextSize;
                                text-align: left;
                            }
                        }
                        .Text {
                            width: 2.5rem;
                            .TextContent {
                                margin-left: 0.08rem;
                                width: calc(100% - 0.08rem - 10px);
                                p {
                                    font-size: $TextSize;
                                    color: #666666;
                                    font-weight: bold;
                                }
                            }
                            i {
                                width: 10px;
                                height: 10px;
                                background-color: #bb4b47;
                                border-radius: 10px;
                                margin-top: 0.02rem;
                            }
                        }
                    }
                }
                .NumberWrap {
                    width: 100%;
                    p {
                        font-size: $TextSize;
                        color: #414141;
                    }
                }
            }
        width: 50%;
        height:calc(100% - 0.8rem);
        top:0.8rem;
        left: 25%;
        position: fixed;
        z-index: 2;
        background-color: #000;
        overflow-y: scroll;
        &::-webkit-scrollbar{
            display: none;
        }
    }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .Item{
            width: 90%;
            margin: 0.05rem auto 0.1rem;
            .List{
                span{
                    font-size: $AdditionTextSize;
                    color: #fff;
                    opacity: 0.7;
                    margin-right: 0.1rem;
                    cursor: pointer;
                }
                span.Active{
                    opacity: 1;
                    font-weight: bold;
                }
            }
        }
        .ContentListWrap{
            width: 90%;
            margin: 0.1rem auto;
            ul{
                width: 100%;
                li{
                    cursor: pointer;
                    width: 100%;
                    border: 1px solid #fff;
                    border-radius: 0.08rem;
                    margin-bottom: 0.1rem;
                    position: relative;
                    padding: 0.04rem 0;
                    .color1{
                        background-color: #339933;
                    }
                    .color3{
                        background-color: #666666;
                    }
                    .color4{
                        background-color: #993333;
                    }
                    .ButtonWrap{
                        width: calc(100% - 0.2rem);
                        margin-left: 0.1rem;
                        margin-top: 0.05rem;
                        .Next{
                            div:first-child{
                                margin-bottom: 0.02rem;
                                p{
                                    font-weight: bold;
                                    margin-bottom: 0.01rem;
                                    opacity: 0.8;
                                    font-size: $TextSize;
                                }
                            }
                            div{
                                p{
                                    font-size: $TitleSize;
                                    color: #fff;
                                    text-align: right;
                                }
                            }
                        }
                        .Type{
                            div{
                                width: 0.4rem;
                                height: 0.15rem;
                                border-radius: 0.2rem;
                                p{
                                    font-size: $TextSize;
                                    color: #fff;
                                }
                            }
                        }
                    }
                    .Time{
                        position: absolute;
                        right: 0.1rem;
                        top: 0.1rem;
                        .Top{
                            margin-bottom: 0.05rem;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                                opacity: 0.7;
                                margin-left: 0.1rem;
                                float: right;
                            }
                        }
                    }
                    .Name{
                        padding: 0.1rem 0 0 0.1rem;
                        p:first-child{
                            font-size: $AdditionTextSize;
                            color: #fff;
                            opacity: 0.7;
                            margin-bottom: 0.05rem;
                        }
                        p:last-child{
                            font-size: $TextSize;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
</style>
